import { render, staticRenderFns } from "./AuthCardHeader.vue?vue&type=template&id=259ce914&scoped=true"
import script from "./AuthCardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthCardHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AuthCardHeader.vue?vue&type=style&index=0&id=259ce914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ce914",
  null
  
)

export default component.exports